import React, { useCallback, useState } from 'react'
import BigNumber from 'bignumber.js'
import styled from 'styled-components'
import { useTranslation } from '@pancakeswap/localization'
import { cronosTokens } from '@pancakeswap/tokens'
import { Modal, Button, Flex, Input, Text } from '@pancakeswap/uikit'
import useCatchTxError from 'hooks/useCatchTxError'
import useToast from 'hooks/useToast'
import { getBalanceAmount, getDecimalAmount } from 'utils/formatBalance'
import useLockToken from '../../../hooks/v2/useLockToken'

const InputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-top: 6px;

  svg {
    width: 24px;
  }
`

const StyledInput = styled(Input)`
  box-shadow: none;
  padding: 0 8px;
  height: 42px;
  width: 100%;
  font-size: 14px;
  z-index: 1;
  border-radius: 6px;

  ${({ theme }) => theme.mediaQueries.sm} {
    font-size: 16px;
    width: 450px;
  }
`

const Display = styled(Text)`
  font-size: 16px;
  font-weight: 500;
`

interface Props {
  id: number
  onDismiss?: () => void
}

const LockListModal: React.FC<Props> = ({
  id,
  onDismiss
}) => {
  const [value, setValue] = useState(0)

  const { t } = useTranslation()
  const { toastSuccess, toastError } = useToast()
  const { fetchWithCatchTxError, loading: pendingTx } = useCatchTxError()
  const candyToken = cronosTokens.candy
  const { onList } = useLockToken()

  const handleChange = useCallback(
    (e: React.FormEvent<HTMLInputElement>) => {
      if (e.currentTarget.validity.valid) {
        const currentValue = Number(e.currentTarget.value.replace(/,/g, '.'))
        setValue(currentValue)
      }
    },
    [],
  )

  const handleList = async () => {
    const receipt = await fetchWithCatchTxError(() => {
      return onList(
        id,
        getDecimalAmount(new BigNumber(value), candyToken.decimals).toFixed()
      )
    })
    if (receipt?.status) {
      toastSuccess(
        `${t('Listed')}!`,
        t('Your lock has been listed for the sale'),
      )
      onDismiss()
    }
  }

  return (
    <Modal title="List Lock" onDismiss={onDismiss}>
      <InputWrapper>
        <Display>{t('Listing Price in CANDY')}</Display>
        <StyledInput
          pattern="^[0-9]*"
          inputMode="decimal"
          step="any"
          min="0"
          disabled={pendingTx}
          onChange={handleChange}
          placeholder="0"
          value={value > 0 ? value : ''}
        />
      </InputWrapper>
      <Flex justifyContent="space-between" mt="24px">
        <Button width='100%' variant="secondary" onClick={onDismiss} mr="8px">
          Cancel
        </Button>
        <Button
          width='100%'
          disabled={pendingTx || value <= 0}
          onClick={handleList}
        >
          List
        </Button>
      </Flex>
    </Modal>
  )
}

export default LockListModal
